import React from "react"
import ReactDOM from "react-dom"
import { PopMask } from "../../shared/layer/index"
import { CloseIcon } from "../../shared/icon"

export function CommonTips(props: { tips: string; onClose: Function }) {
  return ReactDOM.createPortal(
    <>
      <div className="common-tips">
        <span className="close-tips-icon" onClick={() => props.onClose()}>
          <CloseIcon />
        </span>
        <p>{props.tips}</p>
      </div>
      <PopMask onClose={props.onClose} />
    </>,
    document.body
  )
}
